import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import UserSession from './Config/user-session';
import { LoadingService } from './Services/loading.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'HASS.DigitalDiary';
  showNavbar: boolean = false;
  isLoginPage = false;
  constructor(
    private router: Router,
    public loadingService: LoadingService
  ) { }

  ngOnInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const currentRoute = this.getRouteData(event.urlAfterRedirects);

        // Hide or show navbar based on route data
        this.showNavbar = !currentRoute?.hideNavbar;
        this.isLoginPage = !!currentRoute?.hideNavbar;

        // Redirect if login is required and user is not logged in
        if (currentRoute?.requireLogin && !this.isUserLoggedIn()) {
          this.router.navigate(['login'], { queryParams: { returnUrl: event.urlAfterRedirects } });
        }
      }
    });
  }

  // Helper to check user login status
  private isUserLoggedIn(): boolean {
    return !!UserSession.UserID; 
  }

  // Helper to get route data
  private getRouteData(url: string): any {
    const currentRoute = this.router.config.find(route => {
      const path = route.path ? `/${route.path}` : '';
      return url.startsWith(path);
    });
    return currentRoute?.data || {};
  }
}
